export default __webpack_public_path__ + "static/media/emergency_home.a5713195.svg";